import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function RiskReversal() {
  return <section id="guarantee" className="py-14 md:py-24 bg-charcoal relative overflow-hidden" data-id="element-302" data-mp="19b13rijlwbbt">
      <div className="max-w-3xl mx-auto px-6 text-center relative z-10" data-id="element-303" data-mp="1e81ck17ubs6m">
        <FadeIn data-id="element-304" data-mp="1j146wbkfz5nv">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-charcoal-dark border border-amber/30 mb-8" data-id="element-305" data-mp="1j1ndwx8k09n4">
            <ShieldCheckIcon className="w-8 h-8 text-amber" data-id="element-306" data-mp="1s0r04a30p55u" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8" data-id="element-307" data-mp="1s2tzhkq28an8">
            La garantía
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} className="space-y-6 text-lg text-offwhite-dim" data-id="element-308" data-mp="21zggfyf9mhjz">
          <p data-id="element-309" data-mp="2lszapp15o48">
            ELEVATE no te pide perfección. Te pide que seas honesto.
          </p>
          <p className="text-xl md:text-2xl font-heading font-bold text-sand leading-snug" data-id="element-310" data-mp="7kw54ccu3yd9">
            Si en las primeras dos semanas hacés los ejercicios y no sentís que
            algo se mueve, te devuelvo el dinero sin preguntas.
          </p>
          <div className="mt-8 pt-8 border-t border-charcoal-light" data-id="element-311" data-mp="3eevz52pluy76">
            <p className="italic" data-id="element-312" data-mp="39g2rhqx021ex">
              La garantía existe porque el proceso funciona cuando vos trabajás.
            </p>
            <p className="mt-4 text-amber font-medium uppercase tracking-widest text-sm" data-id="element-313" data-mp="35gkah68auahd">
              Sin vueltas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}